import React from 'react'
import './TopBar.css'
import logo from '../../assets/logo_64.png'
import facebook from '../../assets/ic_facebook.svg'
import instagram from '../../assets/ic_instagram.svg'
import twitter from '../../assets/ic_twitter.svg'

const TopBar = () => {
    return (
        <div className="top-bar-layout">
            <div className="secondary-bar" />
            <div className="main-bar">
                <div className="netiapps-logo">
                    <a href="/"><img src={logo} alt="NetiApps Logo" /></a>
                    <p>NetiApps</p>
                </div>
                <div className="navigation">
                    <a href="#apps" className="link">Apps</a>
                    <a href="#contact" className="link">Contact</a>
                    <div className="divider" />
                    <a href="https://www.instagram.com/netiapps_/" className="icon-link"><img src={instagram} alt="Instagram" /></a>
                    <a href="https://www.facebook.com/NETIAppsBest/" className="icon-link"><img src={facebook} alt="Facebook" /></a>
                    <a href="https://twitter.com/_NETIApps" className="icon-link"><img src={twitter} alt="Twitter" /></a>
                </div>
            </div>
        </div>
    )
}

export default TopBar
